import {createColumnHelper} from "@tanstack/react-table";
import {useNavigate} from "react-router-dom";
import DataTable from "../../../components/DataTable/DataTable";
import moment from "moment-timezone";

const columnHelper = createColumnHelper();
const columns = [
    columnHelper.accessor("cowNumber", {
        header: "CowNumber",
        sortingFn: "alphanumeric",
    }),
    columnHelper.accessor(value => moment(value.treatmentDate).format("YYYY-MM-DD"), {
        header: "Date",
        sortingFn: "datetime",
    }),
    columnHelper.accessor("product.name", {
        header: "Type of Antibiotic",
    }),
    columnHelper.accessor("dosage", {
        header: "Dosage",
        cell: info => `${info.getValue()} ${info.row.original.unit}`,
        sortingFn: "alphanumeric",
    }),
    columnHelper.accessor(value => value.reason?.name, {
        header: "Reason",
    }),
    columnHelper.accessor("comments", {
        header: "Comments",
    }),
];

const AntibioticUsagesTable = ({antibioticUsages}) => {
    const navigate = useNavigate();

    return <DataTable title="Antibiotic Usage" data={antibioticUsages} columns={columns} useFilter
                      onRowClick={(row) => navigate(row.id.toString())}/>;
}

export default AntibioticUsagesTable;